<template>
    <div class="kgk-manage-challenges">
      <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
      <div v-else>
        <h1>Challenges List</h1>
        <table>
            <thead>
            <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Start Date</th>
                <th>Stop Date</th>
                <th>Target</th>
                <th>Donate amount</th>
                <th>Enabled</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="challenge in challenges" :key="challenge.identifier">
                <td>{{ challenge.identifier }}</td>
                <td>{{ challenge.name ? challenge.name : '-' }}</td>
                <td>{{ formatDate(challenge.start_date) }}</td>
                <td>{{ formatDate(challenge.stop_date) }}</td>
                <td>{{ challenge.target ? challenge.target : '-' }}</td>
                <td>{{ challenge.donate ? challenge.donate : '-' }}</td>
                <td>{{ challenge.active == 1 ? 'Yes' : 'No' }}</td>
                <td>
                <button @click="editChallenge(challenge)">Edit</button>
                </td>
            </tr>
            </tbody>
        </table>

        <button @click="addChallenge">Add Challenge</button>
    
        <div v-if="isEditing">
            <h2>{{ currentChallenge.identifier ? 'Edit Challenge' : 'Add Challenge' }}</h2>
            <form @submit.prevent="updateChallenge">
            <div>
                <label for="name">Name:</label>
                <input type="text" v-model="currentChallenge.name" />
            </div>
            <div>
                <label for="start_date">Start Date:</label>
                <input type="date" v-model="currentChallenge.start_date" required />
            </div>
            <div>
                <label for="stop_date">Stop Date:</label>
                <input type="date" v-model="currentChallenge.stop_date" required />
            </div>
            <div>
                <label for="stop_date">Target:</label>
                <input type="text" v-model="currentChallenge.target" />
            </div>
            <div>
                <label for="stop_date">Donate amount:</label>
                <input type="text" v-model="currentChallenge.donate" />
            </div>
            <div>
                <label for="active">Enabled:</label>
                <select v-model="currentChallenge.active">
                <option :value="1">Yes</option>
                <option :value="0">No</option>
                </select>
            </div>
            <button type="submit">Update Challenge</button>
            <button type="button" @click="cancelEdit">Cancel</button>
            </form>
        </div>
    </div>
    </div>
  </template>

<script>
    import admin from '../../api/admin';
    import company from '../../api/company';

    export default {
    name: 'ChallengesList',
    props: {
        companyIdentifier: {
        type: String,
        required: true
        }
    },
    data() {
        return {
        challenges: [],
        isEditing: false,
        currentChallenge: {},
        loading:false,
        };
    },
    created() {
        this.fetchChallenges();
    },
    methods: {
        fetchChallenges(){
            this.loading = true;

            let parameter = "";
            parameter = "?companyidentifier="+this.companyIdentifier;

            company.getCompetitions(
                this,
                data => {
                    this.challenges = data['competitions']
                    console.log(data)
                },
                () => this.error,
                () => this.loading = false,
                parameter
            );
        },
        formatDate(dateString) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return new Date(dateString).toLocaleDateString(undefined, options);
        },
        editChallenge(challenge) {
            this.currentChallenge = { ...challenge }; // Create a copy of the challenge
            this.isEditing = true;
        },
        addChallenge() {
            this.currentChallenge = {
                name: '',
                start_date: '',
                stop_date: '',
                target: '',
                donate: '',
                company_identifier:this.companyIdentifier,
                active: 1 // Default to 'Yes'
            };
            this.isEditing = true;
        },
        updateChallenge(){
            this.loading = true;

            company.updateCreateCompetitions(
                this,
                JSON.parse(JSON.stringify(this.currentChallenge)),
                () => {
                    this.fetchChallenges();
                    this.cancelEdit();
                },
                e => {
                    console.error('Error updating challenge:', response.statusText);
                },
                () => {
                    this.loading = false;
                }
            )
        },
        cancelEdit() {
            this.isEditing = false;
            this.currentChallenge = {};
        }
    }
    };
</script>
  
  <style scoped>
  </style>
